import { redirectToAutoEquity, redirectToHomeRefi } from '@/utils/redirect';
import { composeDispatchAndHandle, dispatchDetailsButtonClickEvent } from '@/utils/analyticsEvents';
import { ActiveCards } from './ActiveCards';
import { SpotlightStatus, useDiscoverySection } from '../DiscoverySection/useDiscoverySection';
import { IconCar4, IconHomeHouse } from '@creditas-ui/react';

const ActiveCardsSection = (): JSX.Element => {
  const { isSuccess, homeRefiStatus, autoEquityStatus } = useDiscoverySection();

  if (isSuccess && homeRefiStatus === SpotlightStatus.ACTIVE) {
    return (
      <ActiveCards
        onClick={composeDispatchAndHandle(dispatchDetailsButtonClickEvent, redirectToHomeRefi)}
        icon={{
          desk: <IconHomeHouse color="#49e295" size={32} strokeWidth={0.7} />,
          mobile: <IconHomeHouse color="#49e295" size={30} strokeWidth={0.7} />,
        }}
        titleKey="home"
      />
    );
  }

  if (isSuccess && autoEquityStatus === SpotlightStatus.ACTIVE) {
    return (
      <ActiveCards
        onClick={composeDispatchAndHandle(dispatchDetailsButtonClickEvent, redirectToAutoEquity)}
        icon={{
          desk: <IconCar4 color="#49e295" size={32} strokeWidth={0.7} />,
          mobile: <IconCar4 color="#49e295" size={30} strokeWidth={0.7} />,
        }}
        titleKey="auto"
      />
    );
  }
  return <></>;
};

export { ActiveCardsSection };
